export default __webpack_public_path__ + "static/media/algorandDropdown.571feed3.svg";